import React, { useState } from "react";

//MUI
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";


// Icons
import RouteAddIcon from "@/icons/RouteAddIcon";

//Types
import { DCRecord } from "@/@types/lib/dataController";
import { Collapse, Typography } from "@mui/material";

type LDTStageItemsType =
  {
    items: DCRecord[],
    onClick: (evt: React.MouseEvent<HTMLDivElement>, item: DCRecord) => void
    selectedId?: number,
    itemIcon?: React.ReactElement,
    primaryTextFn: (item: DCRecord) => string | null,
  }

function LDTStageItems(props: LDTStageItemsType) {
  const { items, selectedId, onClick, itemIcon, primaryTextFn } = props;

  return (
    <>
      {Array.isArray(items) ? items.map((item, i) => {

        const selected = selectedId === item["stage_id"] as number;

        const primaryText = primaryTextFn(item);

        return (
          <ListItem key={`item-${item["stage_id"]}`}>
            <ListItemButton dense disableGutters onClick={(evt) => onClick(evt, item)} selected={selected}>
              <ListItemAvatar >
                {itemIcon ? 
                <Avatar sx={{ bgcolor: 'transparent' }}>
                  {itemIcon}
                </Avatar>
                : 
                <Avatar sx={{ width: 30, height: 30, backgroundColor: 'transparent', border: theme => `2px solid ${theme.palette.primary.main}` }}>
                  <Typography color="primary">
                    {item["sortorder"] as number}
                  </Typography>
                </Avatar>
                }
              </ListItemAvatar>
              {
                primaryText && primaryText !== null ?
                  <ListItemText
                    primary={primaryText}
                  /> :
                  <ListItemText
                    primary={primaryText} 
                  />
              }
            </ListItemButton>
          </ListItem>);
        }) : null
      }
    </>);
}

export default LDTStageItems;
